import React from 'react';
import { useTransition } from 'react-spring';

import Toast from './Toast';
import { Container } from './styles';

import { ToastMessage } from '../../hooks/toast';

import { useScrolling } from '../../hooks/scrolling';

interface ToastContainerProps {
  messages: ToastMessage[];
}

const ToastContainer: React.FC<ToastContainerProps> = ({ messages }) => {
  const { scrolled } = useScrolling();

  const messagesWithTransitions = useTransition(
    messages,
    (message) => message.id,
    {
      from: { right: '-120%', opacity: 0, transform: 'scale(0.8)' },
      enter: { right: '0%', opacity: 1, transform: 'scale(1)' },
      leave: { right: '-120%', opacity: 0, transform: 'scale(0.8)' },
    },
  );
  return (
    <Container lower={scrolled > 100}>
      {messagesWithTransitions.map(({ item, key, props }) => (
        <Toast key={key} message={item} style={props} />
      ))}
    </Container>
  );
};

export default ToastContainer;
